export interface StockIndex {
  label: string;
  value: string;
  type: string;
}

export const STOCK_INDEXES: StockIndex[] = [
  {
    label: "Indikation auf Germany 40",
    value: "DE000A4AJCP5",
    type: "market",
  },
  {
    label: "Indikation auf Germany Tech 30",
    value: "DE000A4AJDG2",
    type: "market",
  },
  {
    label: "Indikation auf Germany Mid Cap",
    value: "DE000A4AJC07",
    type: "market",
  },
  {
    label: "Indikation auf Germany Small Caps",
    value: "DE000A4AJDB3",
    type: "market",
  },
  {
    label: "Indikation auf Eurozone 50",
    value: "DE000A4AJCR1",
    type: "market",
  },
  { label: "Indikation auf US 30", value: "DE000A4AJCQ3", type: "market" },
  {
    label: "Indikation auf US Tech 100",
    value: "DE000A4AJC49",
    type: "market",
  },
  { label: "Indikation auf US 500", value: "DE000A4AJC80", type: "market" },
  {
    label: "Indikation auf World Index",
    value: "DE000A4AJC31",
    type: "market",
  },
  {
    label: "Indikation auf Japan 225",
    value: "DE000A4AJC56",
    type: "market",
  },
  { label: "Indikation auf UK 100", value: "DE000A4AJCT7", type: "market" },
];

export const QUOTE_PROVIDERS = {
  ariva: "ariva",
  yahoo: "yf",
  ing: "ing",
  none: "none",
  quandl: "quandl",
  rentablo: "rentablo",
  crypto: "crypto",
  onvista: "ovfs",
};

export const ROLE_MANDATOR_LEVEL_STATISTICS_VIEWER =
  "ROLE_MANDATOR_LEVEL_STATISTICS_VIEWER";
export const ROLE_CROSS_MANDATOR_STATISTICS_VIEWER =
  "ROLE_CROSS_MANDATOR_STATISTICS_VIEWER";
export const ROLE_MASTER_DATA_ADMIN = "ROLE_MASTER_DATA_ADMIN";
export const ROLE_BANKING_API_LOGS_VIEWER = "ROLE_BANKING_API_LOGS_VIEWER";
export const ROLE_MULTIBANKING_API_ADMIN = "ROLE_MULTIBANKING_API_ADMIN";
export const ROLE_CROSS_MANDATOR_BANKING_API_LOGS_VIEWER =
  "ROLE_CROSS_MANDATOR_BANKING_API_LOGS_VIEWER";
export const ROLE_SUBSCRIPTION_ADMIN = "ROLE_SUBSCRIPTION_ADMIN";

export const BOOKINGS_COMPATIBILITY_VERSION = "v_2025_03_06";
export const ROLE_MANDATOR_VIEWER = "ROLE_MANDATOR_VIEWER";
export const ROLE_QUALITY_ASSURANCE = "ROLE_QUALITY_ASSURANCE";
